import { SearchClient } from 'algoliasearch/lite'
import React from 'react'
import { InstantSearch } from 'react-instantsearch-hooks-web'
import routingFactory from './routing'
import VirtualRefinementList from './virtualRefinementList'

type SearchProps = {
  algolia: {
    indexName: string
    searchClient: SearchClient
  }
  restrictions?: Record<string, string[]>
  children?: React.ReactNode
}

const Search: React.FC<SearchProps> = ({
  algolia,
  children = undefined,
  restrictions = {},
}) => (
  <InstantSearch
    searchClient={algolia.searchClient}
    indexName={algolia.indexName}
    routing={routingFactory({
      indexName: algolia.indexName,
      searchRestrictions: restrictions || {},
    })}
    initialUiState={
      restrictions
        ? {
          [algolia.indexName]: {
            refinementList: restrictions,
          },
        }
        : undefined
    }
  >
    {restrictions &&
      Object.keys(restrictions).map((attribute) => (
        <VirtualRefinementList key={attribute} attribute={attribute} />
      ))}
    {children}
  </InstantSearch>
)

export default Search
